<section>
  <div v-if="foundry.options.length > 1">
    <p class="mt-h5" v-if="isLabelRequired && showTitle">
      Select a Foundry
    </p>
    <fou-select :class="[inputWidth, isAllFoundriesOption ? $style.salesReportInput : '']"
      :id="$vId(this, 'set-session-foundry')" :modelValue="foundry.values" :reduce="op => op" :options="foundry.options"
      @option:selected="updateFoundryValues" type="radio" name="foundry" disable-auto-complete
      :placeholder="$t('pages.profile.enter_defaultFoundry')" input-class="full-width">
    </fou-select>
  </div>
  <div v-if="foundry.options.length === 1" :class="$style.foundryName">{{ foundry.options[0].label }}</div>
</section>